import { setGlobalTheme } from '@atlaskit/tokens/set-global-theme';
import { type ThemeState } from '@atlaskit/tokens/theme-config';
import { themeStringToObject } from '@atlaskit/tokens/theme-state-transformer';
import { getBridgeAPI } from '@databases/utils/database/bridge';
import { getQueryParams } from '@databases/utils/urls';

import { currentThemeState } from '@canvas/canvas-state/theme';

import { type BootstrapOptions } from './bootstrap.ts';

const DEFAULT_THEME_STATE: Partial<ThemeState> = {
  light: 'light',
  dark: 'dark',
  colorMode: 'light',
  typography: 'typography',
};

const listenOnThemeChange = async () => {
  const bridge = await getBridgeAPI();

  if (bridge.onThemeChange) {
    bridge.onThemeChange((theme) => {
      changeTheme(theme);
    });
  }
};

export const getThemeStateFromQueryParams = () => {
  const initialThemeParam = getQueryParams().get('themeState');

  if (initialThemeParam) {
    return themeStringToObject(
      decodeURIComponent(initialThemeParam),
    ) as BootstrapOptions['themeState'];
  }
};

export const initializeDatabaseTheme = (initialThemeState?: Partial<ThemeState>) => {
  const themeState = initialThemeState ?? DEFAULT_THEME_STATE;

  changeTheme(themeState);

  listenOnThemeChange();
};

export const changeTheme = (theme: Partial<ThemeState>) => {
  setGlobalTheme(theme);

  currentThemeState.theme = theme.colorMode === 'dark' ? 'dark' : 'light';
};
